module.exports = __webpack_public_path__ + "img/en-pc-step-2.a587e9cf.png";